import axios, { AxiosResponse } from 'axios'
import { ID } from '../../../../../../_metronic/helpers'
import {
  CargoAsoDtoCreate,
  CargoAsoDtoUpdate,
  CargoAsoView,
  CargosClienteQueryResponse,
} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const EMPRESAS_CLIENTE_CARGO_URL = `${API_URL}/empresas/cliente/cargo`

/**
 * Busca todos os cargos de clientes
 * @param idEmpresa Identificador da empresa pai
 * @param query string
 * @returns CargosClienteQueryResponse
 */
export const getCargosCliente = (
  idEmpresa: ID,
  query: string
): Promise<CargosClienteQueryResponse> => {
  return axios
    .get(`${EMPRESAS_CLIENTE_CARGO_URL}?idEmpresa=${idEmpresa}&${query}`)
    .then((d: AxiosResponse<CargosClienteQueryResponse>) => d.data)
}

/**
 * Busca um cargo
 * @param idCargo Identificador do cargo
 * @returns CargoAsoView
 */
export const getCargoClienteById = (idCargo: ID): Promise<CargoAsoView> => {
  return axios
    .get(`${EMPRESAS_CLIENTE_CARGO_URL}/${idCargo}`)
    .then((response: AxiosResponse<CargoAsoView>) => response.data)
}

/**
 * Cadastra um cargo de um cliente
 * @param idEmpresaCliente Identificador da empresa cliente
 * @param cargo CargoAsoDtoCreate
 * @returns CargoAsoView
 */
export const createCargoCliente = (
  idEmpresaCliente: ID,
  cargo: CargoAsoDtoCreate
): Promise<CargoAsoView> => {
  return axios
    .post(`${EMPRESAS_CLIENTE_CARGO_URL}/${idEmpresaCliente}`, cargo)
    .then((response: AxiosResponse<CargoAsoView>) => response.data)
}

/**
 * Altera um cargo de uma empresa cliente
 * @param idCargo Idetificador do cargo
 * @param cargo CargoAsoDtoUpdate
 * @returns CargoAsoView
 */
export const editCargoCliente = (idCargo: ID, cargo: CargoAsoDtoUpdate): Promise<CargoAsoView> => {
  return axios
    .put(`${EMPRESAS_CLIENTE_CARGO_URL}/${idCargo}`, cargo)
    .then((response: AxiosResponse<CargoAsoView>) => response.data)
}

/**
 * Exclui o cargo de um cliente
 * @param idCargo Identificador do cargo
 * @returns void
 */
export const deleteCargoCliente = (idCargo: ID): Promise<void> => {
  return axios.delete(`${EMPRESAS_CLIENTE_CARGO_URL}/${idCargo}`).then(() => {})
}

/**
 * Exclui os cargos de um cliente em lote. O backend não tem exclusão em lote: dispara uma
 * requisição por id, em paralelo, e rejeita se qualquer uma falhar (o erro fica com quem chama).
 * @param cargoIds Identificadores dos cargos para serem deletados
 * @returns void
 */
export const deleteSelectedCargosCliente = (cargoIds: Array<ID>): Promise<void> => {
  return Promise.all(cargoIds.map(deleteCargoCliente)).then(() => {})
}
